import React from 'react';
import useFortniteLeaderboard from 'hooks/use-fortnite-leaderboard';
import { useFortniteLeaderboardContext } from './Context/Context';
import TableBodyRow from './TableBodyRow';

const TableBody = () => {
  const { tournament, session } = useFortniteLeaderboardContext();
  const [items, loaded] = useFortniteLeaderboard({
    eventId: tournament,
    eventWindowId: session,
  });

  if (!loaded) {
    return null;
  }

  return (
    <tbody>
      {items.map(item => <TableBodyRow key={item.teamId} item={item} />)}
    </tbody>
  );
};

export default TableBody;
